import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/home";
import About from "./pages/about";
import Gallery from "./pages/gallery";
import Tour from "./pages/tour";
import DestinationDetail from "./pages/destinationdetail";
import Services from "./pages/services";
import ContactUs from "./pages/contactus";

import ScrollToTop from "./components/scrolltotop/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/tour" element={<Tour />} />
        <Route path="/tour/:id" element={<DestinationDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contactus" element={<ContactUs />} />
      </Routes>
    </>
  );
}

export default App;
